import React from 'react';

import { ADMIN_DASHBOARD } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { DashboardIcon } from '@Generic/icons';

const AdminDashboard = React.lazy(() => import('../../../pages/Admin/Dashboard'));
const PERMITTED_TYPES = 'onboarding|transition|offboarding';

export default {
  label: 'admin-page.dashboard.title',
  group: ADMIN,
  to: '/administration/dashboard/onboarding',
  route: ['/administration/dashboard', `/administration/dashboard/:dashboardType(${PERMITTED_TYPES})`],
  component: AdminDashboard,
  icon: <DashboardIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  area: ADMIN_DASHBOARD,
  hasNavBar: true,
};
